import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

const EVENTS_ENDPOINT = 'event/list';
const STATES_ENDPOINT = 'state/list';
const LAWYERS_ENDPOINT = 'lawyer/list';
const REPRESENTATIVES_ENDPOINT = 'representative/list';
const VOTE_LOCATION_ENDPOINT = 'voteLocation/list';
const MENU_LIST_ENDPOINT = 'menu/list';
const PAGE_LIST_ENDPOINT = 'page/list';
const COPIES_LIST_ENDPOINT = 'genericText/list';

export const getMenuListRequest = async () => {
  const response = await axios.get(`${BASE_URL}${MENU_LIST_ENDPOINT}`);
  return response.data;
};

export const getPageListRequest = async () => {
  const response = await axios.get(`${BASE_URL}${PAGE_LIST_ENDPOINT}`);
  return response.data;
};

export const getAllEventsRequest = async () => {
  const response = await axios.get(`${BASE_URL}${EVENTS_ENDPOINT}`);
  return response.data;
};

export const getAllStatesRequest = async () => {
  const response = await axios.get(`${BASE_URL}${STATES_ENDPOINT}`);
  return response.data;
};

export const getAllLawyersRequest = async () => {
  const response = await axios.get(`${BASE_URL}${LAWYERS_ENDPOINT}`);
  return response.data;
};

export const getAllRrepresentativesRequest = async () => {
  const response = await axios.get(`${BASE_URL}${REPRESENTATIVES_ENDPOINT}`);
  return response.data;
};

export const getAllVoteLocationsRequest = async () => {
  const response = await axios.get(`${BASE_URL}${VOTE_LOCATION_ENDPOINT}`);
  return response.data;
};

export const getCopiesListRequest = async () => {
  const response = await axios.get(`${BASE_URL}${COPIES_LIST_ENDPOINT}`);
  return response.data;
};
